import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SampleArrowNext from './SampleArrowNext';
import SampleArrowPrev from './SampleArrowPrev';
import MenuCard from 'organisms/MenusPLP/AU/Presentation/MenuCard';
import { showCustomizationModalAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import {
  getAndCheck,
  getToOpenMiniPDPModal,
  getValueOrDefaultArray,
  getValueOrDefaultObject,
  isEmptyEvery,
  isMobileDevice,
  isIpadDevice,
  getPDPurl,
  getUserType,
  getDiscountAndCoupon,
  getBackgroundImagePath,
} from 'common/utilities/utils';
import { ChannelManager } from 'common/manager';
import {
  PICK_UP,
  DINE_IN,
  DELIVERY,
  DELIVERY_TEXT,
  DINE_IN_TEXT,
  mockObject,
  LOCAL_STORAGE_KEYS,
  ANALYTICS_SHARED_CONSTANTS,
} from 'common/constants/SharedConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import UpsellCrossell from 'molecules/UpsellCrossell/AU/Presentation/UpsellCrossell';
import { setPrevArrowCSS } from 'organisms/CartPage/AU/Presentation/ReusableComponents/IndulgentAddOn';
import { RecommendProductSelect } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import FoodItemListHandlers from 'organisms/CartPage/AU/Presentation/ReusableComponents/FoodItemListHandlers';
import { RECOMMENDED_CONSTANTS_DATA, RESPONSIVE_CONFIG_DATA } from 'common/utilities/recommendedItemModulator';
const { PLP_PDP_DETAILS } = START_ORDER_CONSTANTS;
const { PDP } = MENU_PDP_PAGE_CONSTANTS;

export const serviceType = disposition => {
  let type = PICK_UP;
  if (disposition === DELIVERY_TEXT) {
    type = DELIVERY;
  }
  if (disposition === DINE_IN_TEXT) {
    type = DINE_IN;
  }
  return type;
};

export const cardsClass = (i, cSlide, FADE_CARD_INDEX) => {
  let dClass = 'recommended-card recommended-card-sopac';
  if (i === cSlide + FADE_CARD_INDEX) {
    dClass += ' recommendedCard-fade';
  }
  return dClass;
};

export const checkCarauselConfigurations = (
  cssClass,
  isIpad,
  CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
  PDP_SLIDES_TO_SHOW,
  SLIDES_TO_SHOW,
  PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
  PDP_SLIDES_TO_SHOW_1024,
) => {
  const maxLengthToScroll =
    cssClass === 'pdp-recommendations' || cssClass === 'pdp-combo'
      ? PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL
      : CONTENT_DATA_MAX_LENGTH_TO_SCROLL;
  const slidesToShow =
    cssClass === 'pdp-recommendations' || cssClass === 'pdp-combo'
      ? (isIpad && PDP_SLIDES_TO_SHOW_1024) || PDP_SLIDES_TO_SHOW
      : SLIDES_TO_SHOW;
  return { maxLengthToScroll, slidesToShow };
};
export const getFilterProductList = (cartData, productList) => {
  const cartDataItemval = cartData?.foodLines?.map(food => food?.item?.id);
  return cartData?.foodLines?.length > 0
    ? productList?.filter(arrval => !cartDataItemval.includes(arrval.id))
    : productList;
};
const RecommendedItem = props => {
  const { PDP_RECOMMENDATIONS, CAROUSAL_CONFIG, CONTENT_DATA_MAX_LENGTH_TO_SCROLL, FADE_CARD_INDEX } =
    RECOMMENDED_CONSTANTS_DATA;
  const { SPEED, SLIDES_TO_SHOW, SLIDES_TO_SCROLL } = CAROUSAL_CONFIG;
  const { PDP_SLIDES_TO_SHOW, PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL, PDP_SLIDES_TO_SHOW_1024 } = PDP_RECOMMENDATIONS;
  const { products, storeClosedData, header = '', subHeader = '', cssClass = '', recommendedRule, source = '' } = props;
  const [rangeValue, updateRangeValue] = useState(0);
  const [currentSlide, updateCurrentSlide] = useState(0);
  const carousal = useRef(null);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [isIpad, setIPadHeader] = useState(isIpadDevice());
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const { maxLengthToScroll, slidesToShow } = checkCarauselConfigurations(
    cssClass,
    isIpad,
    CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
    PDP_SLIDES_TO_SHOW,
    SLIDES_TO_SHOW,
    PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL,
    PDP_SLIDES_TO_SHOW_1024,
  );
  const { dispositionStateData = mockObject } = userOrderState;
  const { dispositionType = localStorage.getItem('dispositionType') } = dispositionStateData;
  const [flagUpsellCrossell] = useState();
  const history = useHistory();
  const { tenantReducer, cartReducer, userParams } = useSelector(data => {
    return {
      tenantReducer: getValueOrDefaultObject(data.tenantReducer),
      cartReducer: getValueOrDefaultObject(data.cartReducer),
      userParams: getValueOrDefaultObject(data.appStateReducer.userStatus),
    };
  });
  const { cartData = {} } = getValueOrDefaultObject(cartReducer);
  const { showProductListingModal = false } = getValueOrDefaultObject(cartReducer);
  const location = useLocation();
  const { PlpProductCard = mockObject } = tenantReducer?.componentOptions || mockObject;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const storeInfo = dispositionNew ? dispositionNew.store : mockObject;
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';

  // Removing hidden products for the recommendations list
  const noHiddens = products?.filter(i => !i.isHidden);

  const productList =
    source === PDP
      ? noHiddens
      : noHiddens?.filter(i => {
          let channel = ChannelManager.channel;
          let type = serviceType(dispositionType);
          return i.channel === channel && i.service === type;
        });
  const { headerData: { pdpBackgroundImage = {} } = {} } = useSelector(state =>
    getValueOrDefaultObject(state?.marketConfigReducer?.response),
  );
  const pdpBackgroundImageData = getBackgroundImagePath(pdpBackgroundImage);
  const { showCartAlert } = FoodItemListHandlers(
    undefined,
    undefined,
    undefined,
    undefined,
    userOrderStateDispatch,
    dispatch,
    undefined,
  );

  //modal open for multiple customization
  const openAlertModal = () => {
    showCartAlert(true);
  };

  const carouselDefaults = {
    dots: false,
    infinite: false,
    speed: SPEED,
    slidesToShow: slidesToShow,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    variableWidth: true,
    responsive: RESPONSIVE_CONFIG_DATA,
  };

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    const isIPadWidth = isIpadDevice();
    setIsMobile(isMobileView);
    setIPadHeader(isIPadWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const onNextCard = () => {
    if (currentSlide < productList.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > productList.length - slidesToShow - 1) {
        updatedCurrentSlide = productList.length - slidesToShow;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      setPrevArrowCSS(updatedCurrentSlide);
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };

  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
    setPrevArrowCSS(currentSlide - SLIDES_TO_SCROLL);
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
    setPrevArrowCSS(e.target.value);
  };

  const settings = {
    ...carouselDefaults,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
  };

  const currentItemDetailsMiniPDP = useSelector(({ menuReducer }) => menuReducer?.currentItemDetails);
  useEffect(() => {
    let toOpen = getToOpenMiniPDPModal(currentItemDetailsMiniPDP, userOrderState);
    if (getAndCheck(toOpen, flagUpsellCrossell === recommendedRule)) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: true,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentItemDetailsMiniPDP, userOrderState.minipdpData.itemId, userOrderState.cartEditClicked]);

  useEffect(() => {
    if (showProductListingModal) {
      dispatch(
        showCustomizationModalAction({
          showProductListingModal: false,
          categorySelected: '',
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const onCardClickHandler = (e, productId, customizable, categoryId, productInfo) => {
    e.preventDefault();
    e.stopPropagation();
    window?.scrollTo(0, 0);
    let ProductDetails = {
      productId,
      customizable,
      categoryId,
      catalogName: catalogs,
      productInfo: productInfo,
      isFromPlp: true,
    };
    const index = productList.map(product => product.id).indexOf(productId);
    const { categoryURL: category_url, productPrice: price, productName: name } = productInfo;
    userOrderStateDispatch({
      type: PLP_PDP_DETAILS,
      value: ProductDetails,
    });
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.PDP_DATA_FOR_UPDATE_FOODLINE,
      value: { id: '', flag: '', foodLineId: '' },
    });
    const { localized = false, loggedIn = false } = getValueOrDefaultObject(userParams);
    const userType = getUserType(localized, loggedIn);
    const discountLinesObj = getDiscountAndCoupon(cartData);
    const { couponCode = '', amount = '' } = getValueOrDefaultObject(discountLinesObj);
    const itemsList = [
      {
        item_name: name[0]?.value,
        item_id: productId,
        price: price,
        coupon: couponCode,
        discount: amount,
        currency: ANALYTICS_SHARED_CONSTANTS.AUD,
        item_category: category_url && category_url[0],
        item_list_name: ANALYTICS_SHARED_CONSTANTS.PDP_UPSELL,
        item_list_id: ANALYTICS_SHARED_CONSTANTS.SR_VALUE,
        index: index,
        quantity: 1,
      },
    ];
    RecommendProductSelect(userType, itemsList);
    localStorage.setItem(LOCAL_STORAGE_KEYS.PRODUCT_DETAILS, JSON.stringify(ProductDetails));
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.RECOMMENDED_SECTION_ITEM_CLICK,
      isFromRecommendedSectionItemClick: true,
    });
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PROMO_MODE,
      value: { pdpPromoPage: false },
    });
    localStorage.removeItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT);
    history.push({
      pathname: getPDPurl(productInfo.categoryURL, productInfo.prodURL, history?.location?.pathname),
    });
  };

  const filterProductList = getFilterProductList(cartData, productList);
  const cardRenderer = () =>
    filterProductList?.map((item, index) => {
      const poprts = getValueOrDefaultArray(item.additionalProperties);
      const additionalProperties =
        poprts.length &&
        poprts.reduce(
          (acc, { key, value }) =>
            (acc = {
              ...acc,
              [key]: value === 'True' ? true : value === 'False' ? false : value,
            }),
          mockObject,
        );
      return (
        <div className={cardsClass(index, currentSlide, FADE_CARD_INDEX)}>
          <MenuCard
            key={item.id}
            item={item}
            cardId={item.id}
            cardType={'medium'}
            RecommendationCardItem={true}
            cardFor={'recommended'}
            configureOptions={PlpProductCard}
            tenantData={tenantReducer}
            servingCount={additionalProperties?.servings}
            button={item.button}
            categoryId={item.categoryUrl}
            customizable={item.customizable}
            onCardClickHandler={onCardClickHandler}
            userParams={userParams}
            dName={item.dname}
            prodURL={item.url} //to update after OS product url
            storeClosedData={storeClosedData}
            data-testid='menu-card-component'
            openAlertModal={openAlertModal}
            serves={item?.content?.serves}
            recommImageSizeFlag={true}
            plpbackgroundImageData={pdpBackgroundImageData}
            {...additionalProperties}
            {...item}
            productContent={item?.content}
          />
        </div>
      );
    });

  return (
    Boolean(productList?.length) && (
      <UpsellCrossell
        cardRenderer={cardRenderer}
        productList={[...filterProductList]}
        carousal={carousal}
        header={header}
        subHeader={subHeader}
        settings={settings}
        maxLengthToScroll={maxLengthToScroll}
        slidesToShow={slidesToShow}
        rangeValue={rangeValue}
        onUpdateRange={onUpdateRange}
        showProductListingModal={showProductListingModal}
        isMobile={isMobile}
        tenantData={tenantReducer}
        flagUpsellCrossell={flagUpsellCrossell}
        {...props}
      />
    )
  );
};

export default RecommendedItem;
